module.exports = __webpack_public_path__ + "8eb297c833d6216140eead8f77501901.svg";